import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {Request} from '@simpli/serialized-request'
import {Contract} from '@/model/resource/Contract'
import {TokenPriced} from '@/model/resource/TokenPriced'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'
import {OrbitRound} from '@/model/resource/OrbitRound'

export class OrbitProject implements IResource {
  idOrbitProjectPk: number = 0

  blockchainVersion: BlockchainVersion | null = null
  contract: Contract | null = null
  tokenPriced: TokenPriced | null = null
  orbitRound: OrbitRound | null = null

  transactionHash: string | null = null

  amount: number | null = null
  assetType: string | null = null
  creatorAddress: string | null = null
  isFunded: boolean | null = null
  active: boolean | null = null
  instanceId: number | null = null
  /** Comma-separated event names the job must count. Null/empty = count all contract events. */
  eventNames: string | null = null
  createdAt: Date | null = null

  get $id() {
    return this.idOrbitProjectPk
  }

  set $id(val) {
    this.idOrbitProjectPk = val
  }

  get $tag() {
    return String(this.idOrbitProjectPk)
  }

  get poolUsdFormatted() {
    const decimals = this.tokenPriced?.decimals
    const price = this.tokenPriced?.lastPriceStored
    if (this.amount == null || decimals == null || !price) return 'N/A'

    const poolUsd = (this.amount / 10 ** Number(decimals)) * Number(price)
    return `US$ ${poolUsd.toFixed(2)}`
  }

  assign(data: Partial<OrbitProject>) {
    Object.assign(this, data)
    return this
  }

  /**
   * Persists a new instance of OrbitProject. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistOrbitProject() {
    return await Request.post(`/client/orbit-project`, this)
      .name('persistOrbitProject')
      .asNumber()
      .getData()
  }

  static async markAllActiveUnfundedAfterContractRefund(
    networkIdentifier?: string | null
  ) {
    return await Request.post(
      `/client/orbit-project/unfund-all-after-refund`,
      undefined,
      {params: networkIdentifier ? {networkIdentifier} : {}}
    )
      .name('unfundAllOrbitProjectsAfterRefund')
      .asNumber()
      .getData()
  }
}
